import api from '@/utils/api';

/**
 * Bulk import a dealer Price list
 * @param {object} bulkImportData - The bulk Import data
 * @param {string} companyId - the companyId
 * @returns {Promise}
 */
const bulkImportDealerPriceList = (bulkImportData, companyId) =>
  api.post(`/dealer/${companyId}/price/bulk-import`, bulkImportData);

export default bulkImportDealerPriceList;
